<div class="container text-center">
      <h3>OUTDOOR ACCESS</h3>
      <h4>PRIVACY POLICY</h4>
      <h5>Last Updated July 9, 2024</h5>    
  </div>  



  <div class="container">
  <p class="c12">
    <span class="c3">Outdoor Access, Inc. (</span
    ><span class="c4">&ldquo;Outdoor Access&rdquo;</span
    ><span class="c3"
      >) is committed to protecting your privacy. We have prepared this
      Privacy Policy to describe to you our practices regarding the Personal
      Data (as defined below) we collect from users of our Website, located at </span
    ><span class="c10"
      ><a
        class="c1"
        href="https://app.outdooraccess.com"
        >app.outdooraccess.com</a
      ></span
    ><span class="c3"
      >&nbsp;and Services. Any terms not defined herein shall have the meaning
      given to them in the associated Terms of Use available at </span
    ><span class="c10"
      ><a
        class="c1"
        href="https://app.outdooraccess.com/user/terms-of-service"
        >https://app.outdooraccess.com/user/terms-of-service</a
      ></span
    ><span class="c3 c8">&nbsp;</span>
  </p>
  <ol class="c5 lst-kix_list_1-0 start" start="1">
    <li class="c11">
      <span class="c4"
        >Questions; Contacting Outdoor Access; Reporting Violations.</span
      ><span class="c3 c8"
        >&nbsp;If you have any questions or concerns or complaints about our
        Privacy Policy or our data collection or processing practices, or if
        you want to report any security violations to us, please contact us at
        the following URL or address:</span
      >
    </li>
  </ol>
  <p class="c19">
    <span class="c10"
      ><a
        class="c1"
        href="https://app.outdooraccess.com/contact-us"
        >https://app.outdooraccess.com/contact-us</a
      ></span
    ><span class="c3 c8"><br /> <a href="mailto:support@outdooraccess.com"> support&#64;outdooraccess.com</a></span>
  </p>
  <ol class="c5 lst-kix_list_1-0" start="2">
    <li class="c15">
      <span class="c4">User Consent.</span
      ><span class="c3 c8"
        >&nbsp;By submitting Personal Data through our Website or Services,
        you agree to the terms of this Privacy Policy and you expressly
        consent to the collection, use and disclosure of your Personal Data in
        accordance with this Privacy Policy.</span
      >
    </li>
    <li class="c2">
      <span class="c4">A Note About Children.</span
      ><span class="c3"
        >&nbsp;We do not intentionally gather Personal Data from visitors who
        are under the age of 13. If a child under 13 submits Personal Data to
        Outdoor Access and we learn that the Personal Data is the information
        of a child under 13, we will attempt to delete the information as soon
        as possible. If you believe that we might have any Personal Data from
        a child under 13, please contact us at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/contact-us"
          >https://app.outdooraccess.com/contact-us</a
        ></span
      ><span class="c3 c8">.</span>
    </li>
    <li class="c2">
      <span class="c4">A Note to Users Outside of the United States.</span
      ><span class="c3 c8"
        >&nbsp;If you are a non-U.S. user of the Website, by visiting the
        Website and providing us with data, you acknowledge and agree that
        your Personal Data may be processed for the purposes identified in the
        Privacy Policy. In addition, your Personal Data may be processed in
        the country in which it was collected and in other countries,
        including the United States, where laws regarding processing of
        Personal Data may be less stringent than the laws in your country. By
        providing your data, you consent to such transfer.</span
      >
    </li>
    <li class="c2">
      <span class="c4">Types of Data We Collect.</span
      ><span class="c3 c8"
        >&nbsp;&quot;Personal Data&quot; means data that allows someone to
        identify or contact you, including, for example, your name, address,
        telephone number, e-mail address, as well as any other non-public
        information about you that is associated with or linked to any of the
        foregoing data. For campers, Personal Data also means: and for
        &ldquo;Anonymous Data&rdquo; means data that is not associated with or
        linked to your Personal Data; Anonymous Data does not, by itself,
        permit the identification of individual persons. We collect Personal
        Data and Anonymous Data, as described below.</span
      >
    </li>
  </ol>

  <div class="text-center">
      <hr class="line hidden-sm hidden-xs">
      <div class="chip"><span> WHAT TYPES OF INFORMATION DOES
       OUTDOOR ACCESS GATHER ABOUT ITS USERS? </span></div>
    </div>
    
    
  <ol class="c5 lst-kix_list_1-1 start" start="1">
    <li class="c0"><span class="c4">Information You Provide to Us.</span></li>
  </ol>
  <ul class="c5 lst-kix_list_1-2 start">
    <li class="c7">
      <span class="c3"
        >We may collect Personal Data from you, such as your first and last
        name, date of birth, e-mail and mailing addresses, and password when
        you create an account to log in to our network (&nbsp;</span
      ><span class="c4">&ldquo;Account&rdquo;</span
      ><span class="c3 c8">&nbsp;).</span>
    </li>
    <li class="c7">
      <span class="c3 c8"
        >If you tell us where you are (e.g., by allowing your mobile device to
        send us your location), we may store and use that information to
        provide you with location-based information and advertising. If you
        want to deactivate this feature, you can deactivate GPS on your mobile
        device.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >When connecting to our Services via a service provider that uniquely
        identifies your mobile device, we may receive this identification and
        use it to offer extended services and/or functionality.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >When you order services on our Website, we will collect all
        information necessary to complete the transaction, including your
        name, credit card information, billing information and shipping
        information. We do not store this information directly on our servers,
        but this information may be shared with third parties who will help
        process and fulfill your purchases. When you submit credit card
        numbers, we encrypt that information using industry standard
        technology.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >When we complete a background check, we will collect all information
        necessary to complete the transaction, including your name, social
        security number, and address. We do not store this information
        directly on our servers, but this information may be shared with third
        parties who will help process your background check. When your social
        security number, we encrypt that information using industry standard
        technology.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >We retain information on your behalf, such as files and messages that
        you store using your Account.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >If you provide us feedback or contact us via e-mail, we will collect
        your name and e-mail address, as well as any other content included in
        the e-mail, to send you a reply.</span
      >
    </li>
    <li class="c7">
      <span class="c3"
        >When you post content (text, images, photographs, messages, comments
        or any other kind of content that is not your e-mail address) on our
        Website, the information contained in your posting will be stored in
        our servers and other users will be able to see it, along with your
        profile photo and any other information that you choose to make public
        on your public profile page (&nbsp;</span
      ><span class="c4">&ldquo;Profile&rdquo;</span
      ><span class="c3 c8"
        >&nbsp;). The information that you provide in your Profile will be
        visible to others, including anonymous visitors to the Website.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >When you participate in one of our surveys, we may collect additional
        profile information.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >We also collect other types of Personal Data that you provide to us
        voluntarily, such as your operating system and version, product
        registration number, and other requested information if you contact us
        via e-mail regarding support for the Services.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >If you participate in a sweepstakes, contest or giveaway on our
        Website, we may ask you for your e-mail address and/or home number (to
        notify you if you win or not). We may also ask for first and last
        names, and sometimes post office addresses to verify your identity. In
        some situations, we may need additional information as a part of the
        entry process, such as a prize selection choice. These sweepstakes and
        contests are voluntary. We recommend that you read the rules for each
        sweepstakes and contest that you enter.</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >We may also collect Personal Data at other points in our Website that
        state that Personal Data is being collected.</span
      >
    </li>
  </ul>
  <ol class="c5 lst-kix_list_1-1" start="2">
    <li class="c0">
      <span class="c4"
        >Information You Provide to Facebook and other Social Networking
        Websites.</span
      ><span class="c3 c8"
        >&nbsp;The Services allow users to access Facebook to interact with
        friends and to share on Facebook through Wall and friends&rsquo; News
        Feeds. If you are already logged into the Services and Facebook or
        another SNS, when you click on &ldquo;Connect with Facebook,&rdquo; or
        a similar connection on another SNS, you will be prompted to merge
        your profiles. If you are already logged into the Services but not
        logged into Facebook or another SNS that we support, when you click on
        &ldquo;Connect with Facebook,&rdquo; or a similar connection on
        another SNS, you will be prompted to enter your SNS credentials or to
        &ldquo;Sign Up&rdquo; for the SNS. By proceeding, you are allowing the
        Services to access your information and you are agreeing to the
        Facebook or other SNS&rsquo;s Terms of Use in your use of the
        Services. Conversely, if you are not currently registered as a user of
        the Services, and you click on &ldquo;Sign in&rdquo; using Facebook or
        another SNS that we support, you will first be asked to enter your
        Facebook or SNS credentials and then be given the option to register
        for the Services. In this case, we may receive information from
        Facebook or another SNS to make it easier for you to create an Account
        on the Website and show our relevant content from your Facebook or SNS
        friends. Once you register on the Website and connect with Facebook or
        another SNS, you will be able to automatically post recent activity
        back to Facebook or the other SNS. Any information that we collect
        from your Facebook or other SNS account may depend on the privacy
        settings you have with that SNS, so please consult the SNS&rsquo;s
        privacy and data practices. You have the option to disable Facebook
        Connect at any time by logging into your Account through the Website
        and going to &quot;Manage account&quot; from the drop-down menu, and
        then clicking &quot;remove&quot; next to Facebook. Further, you can
        edit privacy settings for the reviews that appear on Facebook or
        disconnect your Services activity stream by visiting the Facebook
        Applications Settings page.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Information Collected via Technology.</span>
    </li>
  </ol>
  <ul class="c5 lst-kix_list_1-2 start">
    <li class="c7">
      <span class="c4">Information Collected by Our Servers.</span
      ><span class="c3 c8"
        >&nbsp;To make our Website and Services more useful to you, our
        servers (which may be hosted by a third party service provider)
        collect information from you, including your browser type, operating
        system, Internet Protocol (&ldquo;IP&rdquo;) address (a number that is
        automatically assigned to your computer when you use the Internet,
        which may vary from session to session), domain name, and/or a
        date/time stamp for your visit.</span
      >
    </li>
    <li class="c7">
      <span class="c4">Log Files.</span
      ><span class="c3 c8"
        >&nbsp;As is true of most websites, we gather certain information
        automatically and store it in log files. This information includes IP
        addresses, browser type, Internet service provider
        (&ldquo;ISP&rdquo;), referring/exit pages, operating system, date/time
        stamp, and clickstream data. We use this information to analyze
        trends, administer the Website, track users&rsquo; movements around
        the Website, gather demographic information about our user base as a
        whole, and better tailor our Services to our users&rsquo; needs. For
        example, some of the information may be collected so that when you
        visit the Website or the Services again, it will recognize you and the
        information could then be used to serve advertisements and other
        information appropriate to your interests. Except as noted in this
        Privacy Policy, we do not link this automatically-collected data to
        Personal Data.</span
      >
    </li>
    <li class="c7">
      <span class="c4">Cookies.</span
      ><span class="c3"
        >&nbsp;Like many online services, we use cookies to collect
        information.&nbsp;</span
      ><span class="c4">&ldquo;Cookies&rdquo;</span
      ><span class="c3 c8"
        >&nbsp;are small pieces of information that a website sends to your
        computer&rsquo;s hard drive while you are viewing the website. We may
        use both session Cookies (which expire once you close your web
        browser) and persistent Cookies (which stay on your computer until you
        delete them) to provide you with a more personal and interactive
        experience on our Website. This type of information is collected to
        make the Website more useful to you and to tailor the experience with
        us to meet your special interests and needs.</span
      >
    </li>
    <li class="c7">
      <span class="c4">Pixel Tags.</span
      ><span class="c3">&nbsp;In addition, we use&nbsp;</span
      ><span class="c4">&ldquo;Pixel Tags&rdquo;</span
      ><span class="c3 c8"
        >&nbsp;(also referred to as clear Gifs, Web beacons, or Web bugs).
        Pixel Tags are tiny graphic images with a unique identifier, similar
        in function to Cookies, that are used to track online movements of Web
        users. In contrast to Cookies, which are stored on a user&rsquo;s
        computer hard drive, Pixel Tags are embedded invisibly in Web pages.
        Pixel Tags also allow us to send e-mail messages in a format users can
        read, and they tell us whether e-mails have been opened to ensure that
        we are sending only messages that are of interest to our users. We may
        use this information to reduce or eliminate messages sent to a user.
        We do not tie the information gathered by Pixel Tags to our
        users&rsquo; Personal Data.</span
      >
    </li>
    <li class="c7">
      <span class="c4 c18">How We Respond to Do Not Track Signals.</span
      ><span class="c3">&nbsp;</span
      ><span class="c4"
        >We do not currently respond to &ldquo;do not track&rdquo; signals or
        other mechanisms that might enable Users to opt out of tracking on our
        site.</span
      >
    </li>
    <li class="c7">
      <span class="c4"
        >Analytics Services and Interest-Based Advertising.</span
      ><span class="c3"
        >&nbsp;In addition to the tracking technologies we place, other
        companies may set their own cookies or similar tools when you visit
        our Website. This includes third party analytics services, including
        but not limited to Google Analytics (&nbsp;</span
      ><span class="c4">&ldquo;Analytics Services&rdquo;</span
      ><span class="c3"
        >&nbsp;), that we engage to help analyze how users use the Website, as
        well as third parties that deliver content or offers. We may receive
        reports based on these parties&rsquo; use of these tools on an
        individual or aggregate basis. We use the information we get from
        Analytics Services only to improve our Website and Services. The
        information generated by the Cookies or other technologies about your
        use of our Website and Services (the&nbsp;</span
      ><span class="c4">&ldquo;Analytics Information&rdquo;</span
      ><span class="c3"
        >&nbsp;) is transmitted to the Analytics Services. The Analytics
        Services use Analytics Information to compile reports on user
        activity. The Analytics Services may also transfer information to
        third parties where required to do so by law, or where such third
        parties process Analytics Information on their behalf. Each Analytics
        Services&rsquo; ability to use and share Analytics Information is
        restricted by such Analytics Services&rsquo; Terms of Use and Privacy
        Policy. By using our Website and Services, you consent to the
        processing of data about you by Analytics Services in the manner and
        for the purposes set out above. For a full list of Analytics Services,
        please contact us at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/contact-us"
          >https://app.outdooraccess.com/contact-us</a
        ></span
      ><span class="c3 c8"
        >. We may also partner with ad companies to support out marketing
        efforts, including by serving you ads better tailored to your likely
        interests. If you don&rsquo;t want to take advantage of these
        services, you may be able to opt-out by visiting
        http://www.aboutads.info/ or
        http://networkadvertising.org/choices/.</span
      >
    </li>
  </ul>
  <ol class="c5 lst-kix_list_1-1" start="4">
    <li class="c0">
      <span class="c4">Information Collected from You About Others.</span
      ><span class="c3"
        >&nbsp;If you decide to invite a third party to create an Account, we
        will collect your and the third party&rsquo;s names and e-mail
        addresses to send an e-mail and follow up with the third party. We
        rely upon you to obtain whatever consents from the third party that
        may be required by law to allow us to access and upload the third
        party&rsquo;s names and e-mail addresses as required above. You or the
        third party may contact us at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/contact-us"
          >https://app.outdooraccess.com/contact-us</a
        ></span
      ><span class="c3 c8"
        >&nbsp;request the removal of this information from our database. With
        your permission, we will access your address book, call log and SMS
        log, and import your contacts&rsquo; names, e-mail addresses, phone
        numbers, image, geographic location and Facebook IDs to facilitate
        automatic connection with your friends. We do this only for contact
        matching to help your friends and you find each other. Also, when you
        invite friends to the Services, we will access your Address Book and
        we will import your contacts names and phone numbers in order to
        facilitate the invitation. The e-mail that is sent to your friends
        will come from your e-mail address so that your friends know that you
        want to invite them to visit the Website. We do not store any
        passwords you provide as part of the contact import process. We also
        collect some settings that help us to interpret your data, such as the
        language and keyboard settings that you have established, and the
        phone&rsquo;s carrier, mobile network code and mobile country
        code.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Location Information.</span
      ><span class="c3 c8"
        >&nbsp;If you have enabled location services on your phone, we collect
        your location information to make a map more relevant to your
        location. If you do not want this information collected by us, you can
        disable location services on your phone.</span
      >
    </li>
  </ol>

  <div class="text-center">
      <hr class="line hidden-sm hidden-xs">
      <div class="chip"><span> HOW OUTDOOR ACCESS USES, STORES, AND PROCESSES THE INFORMATION THAT YOU PROVIDE OR MAKE AVAILABLE
        </span></div>
    </div>
    
    

  <ol class="c5 lst-kix_list_1-0" start="6">
    <li class="c2"><span class="c4">Use of Your Personal Data</span></li>
  </ol>
  <ol class="c5 lst-kix_list_1-1 start" start="1">
    <li class="c0">
      <span class="c4">General Use.</span
      ><span class="c3 c8"
        >&nbsp;In general, Personal Data you submit to us is used either to
        respond to requests that you make, or to aid us in serving you better.
        We use your Personal Data in the following ways:</span
      >
    </li>
  </ol>
  <ul class="c5 lst-kix_list_1-2 start">
    <li class="c7">
      <span class="c3 c8"
        >facilitate the creation of and secure your Account on our
        network;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8">identify you as a user in our system;</span>
    </li>
    <li class="c7">
      <span class="c3 c8"
        >provide improved administration of our Website and Services;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8">provide the Services you request;</span>
    </li>
    <li class="c7">
      <span class="c3 c8"
        >improve the quality of experience when you interact with our Website
        and Services;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >send you a welcome e-mail to verify ownership of the e-mail address
        provided when your Account was created;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >send you administrative e-mail notifications, such as security or
        support and maintenance advisories;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >respond to your inquiries related to employment opportunities or
        other requests;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >make telephone calls to you, from time to time, as a part of
        secondary fraud protection or to solicit your feedback;</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >send newsletters, surveys, offers, and other promotional materials
        related to our Services and for other marketing purposes of Outdoor
        Access; and</span
      >
    </li>
    <li class="c7">
      <span class="c3 c8"
        >provide necessary information to relevant parties involved in a
        booking you&rsquo;ve made on the Outdoor Access marketplace</span
      >
    </li>
  </ul>
  <ol class="c5 lst-kix_list_1-1" start="2">
    <li class="c0">
      <span class="c4">User Testimonials and Feedback.</span
      ><span class="c3 c8"
        >&nbsp;We often receive testimonials and comments from users who have
        had positive experiences with our Services. We occasionally publish
        such content. When we publish this content, we may identify our users
        by their first and last name and may also indicate their home city. We
        obtain the user&rsquo;s consent prior to posting his or her name along
        with the testimonial. We may post user feedback on the Website from
        time to time. We will share your feedback with your first name and
        last initial only. If we choose to post your first and last name along
        with your feedback, we will obtain your consent prior to posting you
        name with your feedback. If you make any comments on a blog or forum
        associated with your Website, you should be aware that any Personal
        Data you submit there can be read, collected, or used by other users
        of these forums, and could be used to send you unsolicited messages.
        We are not responsible for the personally identifiable information you
        choose to submit in these blogs and forums.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Creation of Anonymous Data.</span
      ><span class="c3 c8"
        >&nbsp;We may create Anonymous Data records from Personal Data by
        excluding information (such as your name) that makes the data
        personally identifiable to you. We use this Anonymous Data to analyze
        request and usage patterns so that we may enhance the content of our
        Services and improve Website navigation. We reserve the right to use
        Anonymous Data and aggregated and other de-identified information for
        any purpose and disclose Anonymous Data to third parties in our sole
        discretion.</span
      >
    </li>
  </ol>

  <div class="text-center">
      <hr class="line hidden-sm hidden-xs">
      <div class="chip"><span> WHEN OUTDOOR ACCECSS DISCLOSES OR SHARES YOUR PERSONAL INFORMATION, AND TO WHOM</span></div>
    </div>
    
    
  <ol class="c5 lst-kix_list_1-0" start="7">
    <li class="c2">
      <span class="c4">Disclosure of Your Personal Data.</span
      ><span class="c3 c8"
        >&nbsp;We disclose your Personal Data as described below and as
        described elsewhere in this Privacy Policy.</span
      >
    </li>
  </ol>
  <ol class="c5 lst-kix_list_1-1 start" start="1">
    <li class="c0">
      <span class="c4">Users.</span
      ><span class="c3 c8"
        >&nbsp;We will share your Personal data with other Users solely for
        the purpose of providing the Services.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Third Party Service Providers.</span
      ><span class="c3 c8"
        >&nbsp;We may share your Personal Data with third party service
        providers to: provide you with the Services that we offer you through
        our Website; to conduct quality assurance testing; to facilitate
        creation of accounts; to provide technical support; and/or to provide
        other services to the Outdoor Access. These third party service
        providers are required not to use your Personal Data other than to
        provide the services requested by Outdoor Access.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Affiliates.</span
      ><span class="c3"
        >&nbsp;We may share some or all of your Personal Data with our parent
        company, subsidiaries, joint ventures, or other companies under a
        common control (&nbsp;</span
      ><span class="c4">&ldquo;Affiliates&rdquo;</span
      ><span class="c3 c8"
        >&nbsp;), in which case we will require our Affiliates to honor this
        Privacy Policy.</span
      >
    </li>

    <div class="text-center">
        <hr class="line hidden-sm hidden-xs">
        <div class="chip"><span> BUSINESS TRANSFERS BY OUTDOOR ACCESS</span></div>
      </div>    
      

    <li class="c0">
      <span class="c4">Corporate Restructuring.</span
      ><span class="c3 c8"
        >&nbsp;We may share some or all of your Personal Data in connection
        with or during negotiation of any merger, financing, acquisition or
        dissolution transaction or proceeding involving sale, transfer,
        divestiture, or disclosure of all or a portion of our business or
        assets. In the event of an insolvency, bankruptcy, or receivership,
        Personal Data may also be transferred as a business asset. If another
        company acquires our company, business, or assets, that company will
        possess the Personal Data collected by us and will assume the rights
        and obligations regarding your Personal Data as described in this
        Privacy Policy.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Social Networking Websites.</span
      ><span class="c3 c8"
        >&nbsp;Some of our Services may enable you to post content to SNSs
        (e.g., Facebook or Twitter). If you choose to do this, we will provide
        information to such SNSs in accordance with your elections. You
        acknowledge and agree that you are solely responsible for your use of
        those websites and that it is your responsibility to review the terms
        of use and privacy policy of the third party provider of such SNSs. We
        will not be responsible or liable for: (i) the availability or
        accuracy of such SNSs; (ii) the content, products or services on or
        availability of such SNSs; or (iii) your use of any such SNSs.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Public Profile.</span
      ><span class="c3 c8"
        >&nbsp;Certain portions of the information you provide to us may also
        be displayed in your Profile. As an essential element of the Services,
        most of the Personal Data you explicitly provide to us when you
        register or update your Profile is displayed on your Profile. In order
        for your Profile to be made public, you must go to your profile
        settings and then to profile visibility. By default, your Profile is
        not for public viewing. Your photos, posts, friends, and other content
        you post to the Website are also meant for public consumption. We may
        display this content on the Website and further distribute it to a
        wider audience through third party sites and services. Once displayed
        on publicly viewable web pages, that information can be collected and
        used by others. We cannot control who reads your postings or what
        other users may do with the information that you voluntarily post, so
        it is very important that you do not put Personal Data in your posts.
        Once you have posted information publicly, while you will still be
        able to edit and delete it on the Website, you will not be able to
        edit or delete such information cached, collected, and stored
        elsewhere by others (e.g., search engines).</span
      >
    </li>
    <li class="c0">
      <span class="c4">Other Disclosures.</span
      ><span class="c3 c8"
        >&nbsp;Regardless of any choices you make regarding your Personal Data
        (as described below), Outdoor Access may disclose Personal Data if it
        believes in good faith that such disclosure is necessary (a) in
        connection with any legal investigation; (b) to comply with relevant
        laws or to respond to subpoenas or warrants served on Outdoor Access;
        (c) to protect or defend the rights or property of Outdoor Access or
        users of the Website or Services; and/or (d) to investigate or assist
        in preventing any violation or potential violation of the law, this
        Privacy Policy, or our Terms of Use.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Third Party Websites.</span
      ><span class="c3 c8"
        >&nbsp;Our Website may contain links to third party websites. When you
        click on a link to any other website or location, you will leave our
        Website and go to another site, and another entity may collect
        Personal Data or Anonymous Data from you. We have no control over, do
        not review, and cannot be responsible for, these outside websites or
        their content. Please be aware that the terms of this Privacy Policy
        do not apply to these outside websites or content, or to any
        collection of your Personal Data after you click on links to such
        outside websites. We encourage you to read the privacy policies of
        every website you visit. The links to third party websites or
        locations are for your convenience and do not signify our endorsement
        of such third parties or their products, content or websites.</span
      >
    </li>
  </ol>
  <ol class="c5 lst-kix_list_1-0" start="8">
    <li class="c2">
      <span class="c4">Your Choices Regarding Information.</span
      ><span class="c3 c8"
        >&nbsp;You have several choices regarding the use of information on
        our Service:</span
      >
    </li>
  </ol>
  <ol class="c5 lst-kix_list_1-1 start" start="1">
    <li class="c0">
      <span class="c4">Email Communications.</span
      ><span class="c3 c8"
        >&nbsp;We will periodically send you free newsletters and e-mails that
        directly promote the use of our Website or Services. When you receive
        newsletters or promotional communications from us, you may indicate a
        preference to stop receiving further communications from us and you
        will have the opportunity to &ldquo;opt-out&rdquo; by following the
        unsubscribe instructions provided in the e-mail you receive or by
        contacting us directly (please see contact information below). Despite
        your indicated e-mail preferences, we may send you service-related
        communications, including notices of any updates to our Terms of Use
        or Privacy Policy.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Cookies.</span
      ><span class="c3 c8"
        >&nbsp;If you decide at any time that you no longer wish to accept
        Cookies from our Service for any of the purposes described above, then
        you can instruct your browser, by changing its settings, to stop
        accepting Cookies or to prompt you before accepting a Cookie from the
        websites you visit. Consult your browser&rsquo;s technical
        information. If you do not accept Cookies, however, you may not be
        able to use all portions of the Service or all functionality of the
        Service. If you have any questions about how to disable or modify
        Cookies, please let us know at the contact information provided
        below.</span
      >
    </li>


    <div class="text-center">
        <hr class="line hidden-sm hidden-xs">
        <div class="chip"><span> HOW TO ACCESS, CHANGE OR DELETE YOUR INFORMATION, OR CANCEL YOUR OUTDOOR ACCESS ACCOUNT</span></div>
      </div>         
      

    <li class="c0">
      <span class="c4">Changing or Deleting Your Personal Data.</span
      ><span class="c3"
        >&nbsp;All users may review, update, or correct the Personal Data in
        their user account (including any imported contacts) by editing within
        the system or by submitting a request at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/contact-us"
          >https://app.outdooraccess.com/contact-us</a
        ></span
      ><span class="c3"
        >. You may delete your personal data and account by submitting a
        request at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/contact-us"
          >https://app.outdooraccess.com/contact-us</a
        ></span
      ><span class="c3 c8"
        >. If you completely delete all of your Personal Data, then your user
        account may become deactivated. We will use commercially reasonable
        efforts to honor your request. We may retain an archived copy of your
        records as required by law or for legitimate business purposes.</span
      >
    </li>
    <li class="c0">
      <span class="c4">Security of Credit Card.</span
      ><span class="c3 c8"
        >&nbsp;For online payments, we use the payment services of Stripe,
        Inc. (https://stripe.com). We do not process, record or maintain your
        credit card or bank account information. For more information on how
        payments are handled, or to understand the data security and privacy
        afforded such information, please refer to
        https://stripe.com/us/privacy.</span
      >
    </li>
  </ol>


  <div class="text-center">
      <hr class="line hidden-sm hidden-xs">
      <div class="chip"><span>Changes to This Privacy Policy.</span></div>
    </div>    
    
    
  <ol class="c5 lst-kix_list_1-0" start="9">
    <li class="c2">
      <span class="c4">Changes to This Privacy Policy.</span
      ><span class="c3"
        >&nbsp;This Privacy Policy may be updated from time to time for any
        reason. We will notify you of any changes to our Privacy Policy at </span
      ><span class="c10"
        ><a
          class="c1"
          href="https://app.outdooraccess.com/user/privacypolicy"
          >https://app.outdooraccess.com/user/privacypolicy</a
        ></span
      ><span class="c3 c8"
        >&nbsp;and we will change the &ldquo;Last Updated&rdquo; date above.
        You should consult this Privacy Policy regularly for any
        changes.</span
      >
    </li>
  </ol>
  <p class="c20"><span class="c8 c14"></span></p>




</div>
